// frontend/src/components/ProfileCompletionNotice.js
import React from "react";
import { Alert, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ProfileCompletionNotice = ({ user }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!user || user.profileCompleted) {
    return null;
  }

  return (
    <Alert
      severity='info'
      action={
        <Button
          color='inherit'
          size='small'
          onClick={() => navigate("/profile")}
        >
          {t("auth.profile.completeNow")}
        </Button>
      }
    >
      {t("auth.profile.completionNotice")}
    </Alert>
  );
};

export default ProfileCompletionNotice;
